/**
 * Database error patterns
 * Extracted from constants.ts to reduce file size
 */

import type { UserFriendlyError } from "../types";

/**
 * Database error patterns
 */
export const databaseErrorPatterns: Array<{
	pattern: RegExp;
	message: UserFriendlyError | ((match: RegExpMatchArray) => UserFriendlyError);
}> = [
	{
		pattern: /unique constraint|already exists/i,
		message: {
			title: "Élément déjà existant",
			message: "Un élément avec ces informations existe déjà.",
			canRetry: false,
		},
	},
	{
		pattern: /foreign key constraint/i,
		message: {
			title: "Impossible de supprimer",
			message: "Cet élément est lié à d'autres données et ne peut pas être supprimé.",
			canRetry: false,
		},
	},
];

